export default __webpack_public_path__ + "static/media/organizePhone.cc0336ee.png";